import { defineMessages } from 'react-intl';

export default defineMessages({
  yourDeposits: 'Your deposits',
  secondTableColumnTitle: 'Current balance',
  collateral: 'Collateral',

  currentBalanceUSDRowTitle: 'Current balance in USD',
  thirtyDaysAverageTitle: '30 Days Average',

  valueRowTitle: 'Earned',
  apyRowTitle: 'APY',
  useAsCollateralRowTitle: 'Use as collateral',

  withdrawYourDeposit: 'Withdraw your deposit',
  swapYourDeposit: 'Swap your deposit',
  depositMore: 'Deposit more',

  offLabel: 'No',
  onLabel: 'Yes',
});
